import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router';

import React, { useState } from 'react';
import { ProtectedRoute } from './components/ProtectedRoute';
import UnauthorizedPage from "./pages/UnauthorizedPage";
import { routes } from './config/routes';
import { AppProviders } from './context/AppProviders';

const App = () => {
  return (
    <AppProviders>
      <Router>
        <Routes>
          
        {routes.map(({ path, element: Element, protected: isProtected, roles }) => (
            <Route
              key={path}
              path={path}
              element={
                isProtected ? (
                  <ProtectedRoute allowedRoles={roles}>
                    <Element />
                  </ProtectedRoute>
                ) : (
                  <Element />
                )
              }
            />
          ))}

        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        </Routes>
      </Router>
    </AppProviders>
  );
};

export default App;